import * as React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import TaxonomyThemeParent from './Parent';
import TaxonomyThemeChild from './Child';
import { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeWrapper: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const parent = theme.parent[0]?.target_id;

  // If the taxonomy has a parent, it must be a child.
  if (parent) {
    return <TaxonomyThemeChild entity={entity} />;
  }

  // If the taxonomy has no parent, itself must be a parent.
  return <TaxonomyThemeParent entity={entity} />;
};

export default TaxonomyThemeWrapper;
